const isValid = (checkbox, btn) => {
  if(checkbox.checked) {
    btn.removeAttribute('disabled')

    return
  }

  btn.setAttribute('disabled', true)
}

const enableBtn = () => {
  const checkbox = document.querySelector('[enable-btn]')

  if(!checkbox) return

  const btn = document.querySelector(`[enable-btn-target='${checkbox.getAttribute('enable-btn')}']`)

  isValid(checkbox, btn)

  checkbox.addEventListener('change', (e) => {
    isValid(e.currentTarget, btn)
  })
}

export default enableBtn
